import { mapGetters } from "vuex";
import utils from "../../utils/util";
import pageheader from "../pageheader";
// import telematicsService from "../../api/telematics.service";

export default {
  name: "all-reports",
  components: { pageheader },
  props: [],
  data() {
    return {
      input: {},
      isLoading: false,
  
    };
  },
  async created() {
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("reports", this.roles);
  },
  methods: {
   
  },
};
